import {CALL_API, Schemas} from  '../../../middleware/api'


// ------------------------------------
// List Pacientes
// ------------------------------------

export const GET_HISTORIAL_API_LOADING = 'GET_HISTORIAL_API_LOADING';
export const GET_HISTORIAL_API_SUCCESS = 'GET_HISTORIAL_API_SUCCESS';
export const GET_HISTORIAL_API_ERROR = 'GET_HISTORIAL_API_ERROR';

const fetchHistorial = (id) => ({
  [CALL_API]: {
    method: 'GET',
    types: [ GET_HISTORIAL_API_LOADING, GET_HISTORIAL_API_SUCCESS, GET_HISTORIAL_API_ERROR ],
    endpoint: `/pacientes/${id}?projection=historialPacienteProjection&sort=dateCreated,desc`
  }
})

export const getHistorial = (id) => (dispatch, getState) => {
  return dispatch(fetchHistorial(id))
}



// WEBPACK FOOTER //
// ./src/routes/Historial/services/historial.js